import { Box, Group, Text, UnstyledButton } from "@mantine/core";
import { IconChevronDown, IconChevronRight, IconFolder } from "@tabler/icons-react";

export const TreeItem = ({
  name,
  depth = 0,
  isOpen,
  onToggle,
  children,
  isSelected,
  onClick,
  disabled,
}: {
  name: string;
  depth?: number;
  isOpen?: boolean;
  onToggle?: () => void;
  children?: React.ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}) => (
  <Box>
    <UnstyledButton
      onClick={
        disabled
          ? undefined
          : () => {
              onClick?.();
              onToggle?.();
            }
      }
      style={{
        paddingLeft: 8 + depth * 16,
        height: 32,
        width: "100%",
        display: "flex",
        alignItems: "center",
        borderRadius: 4,
        backgroundColor: isSelected ? "#e6f4ff" : undefined,
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <Group spacing="xs">
        {onToggle && (isOpen ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />)}
        <IconFolder size={16} />
        <Text size="sm">{name}</Text>
      </Group>
    </UnstyledButton>
    {isOpen && children}
  </Box>
);
